import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import abimg from "../../images/about/ab.png";
import { getBusinessSettings } from "../../api/getBusinessSettings";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const About3 = () => {
  const [settings, setSettings] = useState(null);
  const [mainImage, setMainImage] = useState(null);
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

  useEffect(() => {
    getBusinessSettings().then((data) => {
      setSettings(data);
      if (data?.images && data.images.length > 0) {
        setMainImage(data.images[0]); // default to first image
      }
    });
  }, []);

  if (!settings) return null;

  const imagesArray = settings.images || [];

  return (
    <section 
        className="wpo-about-section-s3 section-padding"
        style={{
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            paddingBottom: "60px",
        }}
    >
      <div className="container">
        <div 
          className="wpo-about-inner"
          style={{
          background: "linear-gradient(135deg, #001f4d, #66b2ff, #e6f2ff, #ffffff)"
        }}
        >
          <div className="row align-items-center justify-content-center">
            {/* LEFT SIDE - IMAGES WITH ZOOM & THUMBNAILS */}
            <div className="col-xl-5 col-lg-6 col-md-12 col-12">
              <div className="wpo-about-wrap text-center">
                {/* MAIN IMAGE (Zoom) */}
                <div className="wpo-about-img mb-4">
                  <div className="inner-img">
                    <Zoom>
                      <img
                        src={`${apiUrl}/storage/${mainImage}` || abimg}
                        alt="About main"
                        style={{
                          width: "483px",
                          height: "300px",
                          objectFit: "cover",
                          boxShadow: "0 10px 25px rgba(0, 0, 50, 0.6)",
                          borderRadius: "15px",
                        }}
                      />
                    </Zoom>
                  </div>
                </div>

                {/* THUMBNAILS */}
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  {imagesArray.map((img, index) => (
                    <img
                      key={index}
                      src={`${apiUrl}/storage/${img}`}
                      alt={`About thumbnail ${index}`}
                      onClick={() => setMainImage(img)}
                      style={{
                        width: "90px",
                        height: "90px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        cursor: "pointer",
                        border:
                          mainImage === img
                            ? "2px solid #000"
                            : "1px solid #ccc",
                        transition: "border 0.2s ease-in-out",
                        boxShadow: "0 10px 25px rgba(0, 0, 50, 0.6)",
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* RIGHT SIDE - TEXT CONTENT */}
            <div className="col-xl-5 col-lg-6 col-md-12 col-12">
              <div className="wpo-about-text">
                <h4
                  style={{
                    color: "black"
                  }}
                >STAR FAMILY INDUSTRIAL PLC</h4>
                
                <h2 style={{ fontSize: "1.5rem", fontWeight: "600", lineHeight: "1.3" }}>
                  We are trusted Import - Export Industrial PLC
                </h2>
                <p
                  style={{
                    textAlign: "justify"
                  }}
                  dangerouslySetInnerHTML={{
                    __html: settings.mission
                  }}
                />

                <div className="text-sub-wrap">
                  <div className="text-sub-item">
                    <i
                      className="fi flaticon-tax"
                      style={{
                        fontSize: "36px",
                        color: "#001f4d",
                        background: "linear-gradient(135deg, #001f4d, #66b2ff)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        marginRight: "12px",
                      }}
                    ></i>
                    <h5 style={{ fontSize: "1.2rem", fontWeight: "400", lineHeight: "1.6", textAlign: "justify" }}>
                      Our core business areas include the export of coffee, oil seeds, 
                      live animals, and spices, as well as importing and distributing tyres 
                      and engaging in real estate development, farming, and mineral production
                    </h5>
                  </div>
                </div>

                <Link
                onClick={ClickHandler}
                to="/service"
                style={{
                  display: "inline-block",
                  padding: "12px 28px",
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "#fff",
                  background: "linear-gradient(135deg, #001f4d, #66b2ff)",
                  border: "none",
                  borderRadius: "8px",
                  textDecoration: "none",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 10px rgba(0, 31, 77, 0.4)",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "linear-gradient(135deg, #004080, #80bfff)";
                  e.target.style.boxShadow = "0 6px 15px rgba(0, 64, 128, 0.5)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "linear-gradient(135deg, #001f4d, #66b2ff)";
                  e.target.style.boxShadow = "0 4px 10px rgba(0, 31, 77, 0.4)";
                }}
              >
                Our Services
              </Link>
              </div>
            </div>
          </div>

          <div
            className="shape-ab"
            style={{
              position: "absolute",
              right: window.innerWidth <= 767 ? "-50px" : "-150px",
              bottom: window.innerWidth <= 767 ? "-80px" : "-180px",
              width:
                window.innerWidth <= 575
                  ? "160px"
                  : window.innerWidth <= 767
                  ? "200px"
                  : "330px",
              height:
                window.innerWidth <= 575
                  ? "160px"
                  : window.innerWidth <= 767
                  ? "200px"
                  : "330px",
              background: "linear-gradient(135deg, #001f4d, #66b2ff)",
              borderRadius: "40px",
              transform: "rotate(20deg)",
            }}
          >
            {/* Inner border (pseudo-element equivalent) */}
            <div
              style={{
                position: "absolute",
                left: "-30px",
                top: "30px",
                width: "100%",
                height: "100%",
                border: "1px solid #14212b",
                borderRadius: "40px",
                content: '""',
              }}
            ></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About3;
